import { Component, Input } from '@angular/core';
import { EventItem } from '../../../interfaces/event';

@Component({
  selector: 'app-event-item',
  templateUrl: './event-item.component.html',
  styleUrls: ['./event-item.component.scss']
})
export class EventItemComponent {
  @Input({required: true}) event!: EventItem;
  @Input() atTimeText: string = '';
  @Input() upToText: string = '';
  @Input() isLoading: boolean = false;
}
